import { getToken } from '@/utils/auth'
import request from '@/utils/request'

// AI聊天 - 流式响应(返回fetch响应，用于旧逻辑兼容)
export async function aiChatTest(chatId, prompt) {
    try {
        const response = await fetch(`${import.meta.env.VITE_APP_BASE_API}/ai/chat/test1`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                'Authorization': getToken()
            },
            body: new URLSearchParams({ prompt, chatId })
        });
        return response;
    } catch (error) {
        console.error('AI Chat Error:', error);
        throw error;
    }
}

/**
 * AI聊天 - 真流式响应(生成器函数)
 * @param {string} chatId 会话ID
 * @param {string} prompt 用户输入
 * @returns {AsyncGenerator} 生成器，每次yield一个SSE事件数据
 */
export async function* aiChatStream(chatId, prompt) {
    const response = await fetch(`${import.meta.env.VITE_APP_BASE_API}/ai/chat/test1`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            'Authorization': getToken()
        },
        body: new URLSearchParams({ prompt, chatId })
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop();

            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed) continue

                // 解析 data: 前缀
                if (trimmed.startsWith('data:')) {
                    const data = trimmed.slice(5).trim();
                    if (data && data !== '[DONE]') {
                        try {
                            yield JSON.parse(data);
                        } catch (e) {
                            console.warn('JSON解析失败:', data);
                        }
                    }
                }
            }
        }
    } finally {
        reader.releaseLock();
    }
}

// 获取聊天历史
export function listChat(chatId) {
    return request({
        url: `/ai/history/chat/${chatId}`,
        method: 'get'
    });
}

// 获取或创建会话(传入用户id, 查询最近一次会话记录, 如果没有则自动创建)
export function getOrCreateSession(userId) {
    return request({
        url: `/ai/aiChatSession/getOrCreate/${userId}`,
        method: 'get'
    });
}

// 查询用户的所有会话列表(用于历史会话选择)
export function listSessionByUser(userId) {
    return request({
        url: `/ai/aiChatSession/listByUser/${userId}`,
        method: 'get'
    });
}

// 新建会话(强制创建新会话, 不复用已有会话)
export function createNewSessionApi(userId) {
    return request({
        url: `/ai/aiChatSession/createNew/${userId}`,
        method: 'get'
    });
}

// 分页查询用户会话列表
export function paginationSessionByUser(data) {
    return request({
        url: `/ai/aiChatSession/pagination`,
        method: 'post',
        data
    });
}

// 删除会话(同时删除会话下的消息)
export function deleteSession(sessionId) {
    return request({
        url: `/ai/aiChatSession/remove/${sessionId}`,
        method: 'post'
    });
}

// 会话附件分页(前端轮询此接口)
export function listAttachmentsBySession(sessionId, params = {}) {
    return request({
        url: `/ai/reportAttachment/listBySession/${sessionId}`,
        method: 'get',
        params: {
            pageNum: params.pageNum || 1,
            pageSize: params.pageSize || 20,
            attachType: params.attachType || ''
        }
    });
}

// 删除附件(不删 FileStorage,只是从会话附件 Tab 移除)
export function removeAttachment(id) {
    return request({
        url: `/ai/reportAttachment/remove/${id}`,
        method: 'get'
    });
}
